<template>
  <div class="HomePage">
    <div class="HomePage-background">
      <div class="HomePage-hear">
        <div class="HomePage-hear-category">
          <router-link :to="{path: 'payment'}">
            <div class="HomePage-hear-category-content">
              <img src="../../public/obraoag/HomePayment.png" alt="">
              <span>付款</span>
            </div>
          </router-link>
          <router-link :to="{path: 'CardBag',query: {HoCardBag: '0'}}">
            <div class="HomePage-hear-category-content">
              <img src="../../public/obraoag/HomeCardBag.png" alt="">
              <span>卡包</span>
            </div>
          </router-link>
          <router-link :to="{path: 'CardBag',query: {HoCardBag: '1'}}">
            <div class="HomePage-hear-category-content">
              <img src="../../public/obraoag/HomeBill.png" alt="">
              <span>账单</span>
            </div>
          </router-link>
        </div>
      </div>
      <div class="HomePage-function">
        <div class="HomePage-function-categorg HomePage-function-GoForOpel">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '0'}}">
            <img src="../../public/obraoag/HomeGoForOpel.png" alt="">
            <p>充欧宝</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-AgaiOpel">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '1'}}">
            <img src="../../public/obraoag/HomeAgaiOpel.png" alt="">
            <p>兑欧宝</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-balance">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '2'}}">
            <img src="../../public/obraoag/HomeBalance.png" alt="">
            <p>余额</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-integral">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '3'}}">
            <img src="../../public/obraoag/HomeIntegral.png" alt="">
            <p>积分</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-tranUnts">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '4'}}">
            <img src="../../public/obraoag/HomeTranUnts.png" alt="">
            <p>转账</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-TranOsit">
          <router-link :to="{path: 'SelectCard',query: {HoSelect: '5'}}">
            <img src="../../public/obraoag/HomeTranOsit.png" alt="">
            <p>转存</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-PurcCard">
          <router-link :to="{path: 'PurcCard'}">
            <img src="../../public/obraoag/HomePurcCard.png" alt="">
            <p>购卡</p>
          </router-link>
        </div>
        <div class="HomePage-function-categorg HomePage-function-service">
          <router-link :to="{path: 'service'}">
            <img src="../../public/obraoag/HomeService.png" alt="">
            <p>服务</p>
          </router-link>
        </div>
      </div>
      <router-link :to="{path: 'MessCent'}">
        <div class="HomePage-Push">
          <div class="HomePage-Push-left">
            <img src="../../public/obraoag/HomeNews.png" alt="">
          </div>
          <div class="HomePage-Push-right">
            <p v-if="this.homeinta[0]">{{this.homeinta[0].NAME}}</p>
            <p v-else>暂无数据</p>
            <p v-if="this.homeinta[1]">{{this.homeinta[1].NAME}}</p>
            <p v-else>暂无数据</p>
          </div>
        </div>
      </router-link>
      <div class="HomePage-Carousel">
        <swiper :options="swiperOptions" ref="mySwiper">
          <swiper-slide><img src="../../public/obraoag/homeshll.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/homeprty.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/homehotl.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/homeprpe.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/homephon.png" alt=""></swiper-slide>
          <swiper-slide><img src="../../public/obraoag/homegift.png" alt=""></swiper-slide>
        </swiper>
      </div>
      <div class="HomePage-project">
        <div class="HomePage-project-sulent HomePage-project-content" @click="homagn(0)">
          <img src="../../public/obraoag/HomeShopMall.png" alt="">
          <p>商城</p>
        </div>
        <router-link :to="{path: 'hotel'}" class="HomePage-project-sulent">
          <div class="HomePage-project-content">
            <img src="../../public/obraoag/HomeHotel.png" alt="">
            <p>酒店</p>
          </div>
        </router-link>
        <router-link :to="{path: 'HousPrty'}" class="HomePage-project-sulent">
          <div class="HomePage-project-content">
            <img src="../../public/obraoag//HomeHouseProp.png" alt="">
            <p>房产</p>
          </div>
        </router-link>
        <router-link :to="{path: 'hosphome'}" class="HomePage-project-sulent">
          <div class="HomePage-project-content">
            <img src="../../public/obraoag/Homemecr.png" alt="">
            <p>医疗健康</p>
          </div>
        </router-link>
        <!-- <div class="HomePage-project-sulent HomePage-project-content" @click="homagn(1)">
          <img src="../../public/obraoag/haicty.png" alt="">
          <p>海悦城</p>
        </div> -->
      </div>
      <!-- 底部导航 -->
      <div class="HomePage-Navition">
        <div class="HomePage-Navition-content HomePage-Navition-hoge">
          <img src="../../public/obraoag/HomePageSelect.png" alt="">
          <span>首页</span>
        </div>
        <router-link :to="{path: 'outlets'}">
          <div class="HomePage-Navition-content HomePage-Navition-cork">
            <img src="../../public/obraoag/HomeFind.png" alt="">
            <span>商业网点</span>
          </div>
        </router-link>
        <router-link :to="{path: 'PersCent'}">
          <div class="HomePage-Navition-content HomePage-Navition-size">
            <img src="../../public/obraoag/HomeMy.png" alt="">
            <span>我的</span>
          </div>
        </router-link>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + homefail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{hometips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + homelong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
import PageLong from '.././components/PageLong.vue';
export default {
  components: {
    PageLong
  },
  data () {
    return{
      loginID: '',
      homefail: 'none',
      hometips: '',
      homeinta: '',
      homelong: 'block',
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false
        }
      },
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    if(!this.loginID){
      this.$router.push({name: 'signin'});
    }
    // 消息中心
    this.$axios.post('app/sysMessage',this.$qs.stringify({}),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.homelong = 'none';
      if(res.status == '200'){
        this.homeinta = res.data.message;
      }else{
        this.hometips = '状态码错误';
        this.homefail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.homefail = 'none';
        },1200)
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {
    
  },
  methods: {
    // 把商城标识添加到缓存
    homagn(hoalsn){
      if(hoalsn == '0'){
        localStorage.setItem("usmago", "0");
        this.$router.push({name: 'shopmall'});
      }else if(hoalsn == '1'){
        localStorage.setItem("usmago", "1");
        this.$router.push({name: 'pointsal'});
      }
    }
  }
}
</script>

<style scoped>
  @import "obraocs/HomePage.css";
</style>